const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

(function applySteinKunstWerkPerformanceGuards() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const html = document.documentElement;
  const isInteractionHeavy = path === '/collections/skandi-design' || path === '/pages/wissen';
  const isHome = path === '/';
  const isDuftCollection = path === '/collections/duftkerzen-mit-glas';
  const isSearch = path === '/search';
  const isBottleProduct = path === '/products/flaschenkerze-2014-beerenauslese-bechtheimer-stein-dreissigacker';

  if (isInteractionHeavy) html.classList.add('skw-perf-interaction');
  if (isHome) html.classList.add('skw-perf-home');
  if (isDuftCollection) html.classList.add('skw-perf-duft-collection');
  if (isSearch) html.classList.add('skw-perf-search');
  if (isBottleProduct) html.classList.add('skw-perf-bottle-product');

  const style = document.createElement('style');
  style.id = 'skw-url-performance-fixes';
  style.textContent = `
    html.skw-perf-interaction .scroll-trigger,
    html.skw-perf-home .scroll-trigger {
      opacity: 1 !important;
      transform: none !important;
      animation: none !important;
      transition: none !important;
    }
    html.skw-perf-interaction body[class*="animate--hover-"] .card-wrapper .card,
    html.skw-perf-interaction body[class*="animate--hover-"] .card-wrapper .card__inner,
    html.skw-perf-home body[class*="animate--hover-"] .card-wrapper .card,
    html.skw-perf-home body[class*="animate--hover-"] .card-wrapper .card__inner {
      transform: none !important;
      transition-duration: 0s !important;
      filter: none !important;
    }
    html.skw-perf-interaction #MainContent > .shopify-section:nth-child(n+3) {
      content-visibility: auto;
      contain-intrinsic-size: 1px 760px;
    }
    html.skw-perf-duft-collection .product-grid .card__inner.ratio,
    html.skw-perf-search .product-grid .card__inner.ratio {
      aspect-ratio: 1 / 1;
    }
    html.skw-perf-duft-collection .card-information .rating,
    html.skw-perf-duft-collection .card-information .price,
    html.skw-perf-search .card-information .rating,
    html.skw-perf-search .card-information .price {
      min-height: 2.2rem;
    }
    html.skw-perf-search .product-grid-container {
      min-height: 55vh;
    }
    html.skw-perf-search .template-search__results {
      min-height: 40rem;
    }
    html.skw-perf-bottle-product .product__media-wrapper {
      min-height: min(72vw, 68rem);
    }
    html.skw-perf-bottle-product .product__info-container > [id^="price-"],
    html.skw-perf-bottle-product .product__info-container .product-form,
    html.skw-perf-bottle-product .product__info-container .rating-wrapper {
      min-height: 3rem;
    }
    html.skw-perf-home .banner__media,
    html.skw-perf-home .slideshow__media {
      contain: layout paint;
    }
    [id$="__1770638407115aa465"] {
      display: none !important;
    }
    @media screen and (max-width: 749px) {
      html.skw-perf-bottle-product .product__media-wrapper {
        min-height: 92vw;
      }
      html.skw-perf-search .template-search__results {
        min-height: 28rem;
      }
    }
  `;
  document.head.appendChild(style);

  function productSignature(container) {
    return Array.from(container.querySelectorAll('a[href*="/products/"]'))
      .map((link) => {
        try {
          return new URL(link.href, window.location.origin).pathname;
        } catch (error) {
          return link.getAttribute('href') || '';
        }
      })
      .filter(Boolean)
      .slice(0, 20)
      .join('|');
  }

  function removeDuplicateHomeProductRows() {
    if (!isHome) return;

    const productSections = Array.from(document.querySelectorAll('#MainContent .shopify-section')).filter((section) => {
      const heading = section.querySelector('h1, h2, h3, .title');
      const headingText = heading ? heading.textContent.trim().toLowerCase() : '';
      return headingText.includes('neu & handverlesen') || section.querySelectorAll('a[href*="/products/"]').length >= 4;
    });

    const seen = new Map();
    productSections.forEach((section) => {
      const signature = productSignature(section);
      if (!signature) return;
      if (seen.has(signature)) {
        section.remove();
      } else {
        seen.set(signature, section);
      }
    });

    document.querySelectorAll('#MainContent ul, #MainContent ol').forEach((list) => {
      const items = Array.from(list.children).filter((item) => item.querySelector && item.querySelector('a[href*="/products/"]'));
      if (items.length < 8 || items.length % 2 !== 0) return;
      const half = items.length / 2;
      const first = items.slice(0, half).map((item) => productSignature(item));
      const second = items.slice(half).map((item) => productSignature(item));
      if (first.every((value, index) => value && value === second[index])) {
        items.slice(half).forEach((item) => item.remove());
      }
    });
  }

  function removeFooterCompletion() {
    const knownSection = document.querySelector('[id$="__1770638407115aa465"]');
    if (knownSection) knownSection.remove();

    document.querySelectorAll('.skw-footer-center').forEach((footerCenter) => {
      const section = footerCenter.closest('.shopify-section');
      if (section && !section.querySelector('.skw-footer')) {
        section.remove();
      }
    });
  }

  function cleanupDuplicateOutput() {
    removeDuplicateHomeProductRows();
    removeFooterCompletion();
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (isInteractionHeavy || isHome) {
      document.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      });
    }

    if (isHome) {
      document.querySelectorAll('slideshow-component').forEach((slider) => {
        const autoplayButton = slider.querySelector('.slideshow__autoplay');
        if (autoplayButton && !autoplayButton.classList.contains('slideshow__autoplay--paused')) autoplayButton.click();
        const list = slider.querySelector('[data-autoplay="true"]');
        if (list) list.setAttribute('data-autoplay', 'false');
      });
    }

    cleanupDuplicateOutput();
    setTimeout(cleanupDuplicateOutput, 300);
    setTimeout(cleanupDuplicateOutput, 1200);

    const originalInitializer = window.initializeScrollAnimationTrigger;
    if (typeof originalInitializer === 'function' && !originalInitializer.__skwSafe) {
      const safeInitializer = function(rootEl = document, isDesignModeEvent = false) {
        if (!rootEl || typeof rootEl.getElementsByClassName !== 'function') {
          rootEl = document.getElementById('ProductGridContainer') || document;
        }
        return originalInitializer(rootEl, isDesignModeEvent);
      };
      safeInitializer.__skwSafe = true;
      window.initializeScrollAnimationTrigger = safeInitializer;
    }
  }, { once: true });
})();

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  if (!rootEl || typeof rootEl.getElementsByClassName !== 'function') {
    rootEl = document.getElementById('ProductGridContainer') || document;
  }
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path === '/' || path === '/collections/skandi-design' || path === '/pages/wissen') {
    animationTriggerElements.forEach((element) => {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    });
    return;
  }

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => element.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, { rootMargin: '0px 0px -50px 0px' });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path === '/' || path === '/collections/skandi-design' || path === '/pages/wissen') return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => { elementIsVisible = entry.isIntersecting; });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    window.addEventListener('scroll', throttle(() => {
      if (!elementIsVisible) return;
      element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    }, 100), { passive: true });
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;
  if (elementPositionY > scrollY + viewportHeight) return 0;
  if (elementPositionY + elementHeight < scrollY) return 100;
  const distance = scrollY + viewportHeight - elementPositionY;
  return Math.round(distance / ((viewportHeight + elementHeight) / 100));
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
